import { Analytics } from "@vercel/analytics/react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import Intro from "./components/Intro";
import More from "./components/More";
import Nav from "./components/Nav";
import WorkExperience from "./components/WorkExperience";

function App() {
  return (
    <Router>
      <div className="App">
        <Nav />
        <main className="main">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Intro />
                  <WorkExperience />
                  {/* <Education /> */}
                  {/* <Projects /> */}
                  {/* <Contact /> */}
                </>
              }
            />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/more" element={<More />} />
          </Routes>
        </main>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
